export const environment = {
  production: false,
  //baseUrl: 'http://127.0.0.1:8000/api'
  
  baseUrl: 'https://server.mpishop.com/api',
  siteUrl: 'https://mpishop.com'  

};